module.exports = __webpack_public_path__ + "static/img/pop.cc6a066.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2dmap/pop.png
// module id = RW4Q
// module chunks = 2